import React from 'react';
import {
    CheckCircleIcon,
    CalendarIcon,
    UserIcon,
    ClockIcon,
    AdjustmentsHorizontalIcon
} from '@heroicons/react/24/outline';
import moment from 'moment';

const BookingConfirmationModal = ({ isOpen, onClose, appointmentData, onViewAppointments }) => {
    if (!isOpen || !appointmentData) return null;

    const appointmentDate = appointmentData.date || appointmentData.appointment?.date;
    const startTime = appointmentData.startTime || appointmentData.starttime || appointmentData.appointment?.startTime || appointmentData.appointment?.starttime;
    const duration = appointmentData.duration || appointmentData.appointment?.duration;
    const providerName = appointmentData.providerName || appointmentData.appointment?.providerName || 'Healthcare Provider';

    return (
        <div className="fixed z-50 inset-0 overflow-y-auto">
            <div className="flex items-center justify-center min-h-screen px-4">
                <div className="fixed inset-0 bg-black opacity-40 transition-opacity" onClick={onClose} />

                <div
                    className="relative bg-white rounded-xl max-w-md w-full mx-auto p-6 shadow-2xl transform transition-all"
                    onClick={(e) => e.stopPropagation()}
                >
                    <div className="text-center">
                        <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-green-100 mb-5">
                            <CheckCircleIcon className="h-10 w-10 text-green-600" />
                        </div>

                        <h2 className="text-2xl font-bold text-gray-900 mb-2">
                            Appointment Booked!
                        </h2>

                        <p className="text-sm text-gray-500 mb-6">
                            Your appointment has been successfully scheduled. We look forward to seeing you.
                        </p>

                        <div className="bg-gray-50 rounded-xl p-5 mb-6 text-left border border-gray-100 shadow-sm">
                            <div className="space-y-4">
                                <div className="flex items-center text-gray-700">
                                    <CalendarIcon className="h-5 w-5 mr-3 text-blue-600 flex-shrink-0" />
                                    <span className="font-medium text-[15px]">
                                        {appointmentDate ? moment(appointmentDate).format('dddd, MMMM D, YYYY') : 'Date TBD'}
                                    </span>
                                </div>
                                <div className="flex items-center text-gray-700">
                                    <ClockIcon className="h-5 w-5 mr-3 text-blue-600 flex-shrink-0" />
                                    <span className="font-medium text-[15px]">
                                        {startTime ? moment(startTime, ['HH:mm', 'hh:mm A']).format('h:mm A') : 'Time TBD'}
                                    </span>
                                </div>
                                {duration && (
                                    <div className="flex items-center text-gray-700">
                                        <AdjustmentsHorizontalIcon className="h-5 w-5 mr-3 text-blue-600 flex-shrink-0" />
                                        <span className="font-medium text-[15px]">
                                            {duration} minutes
                                        </span>
                                    </div>
                                )}
                                <div className="flex items-center text-gray-700">
                                    <UserIcon className="h-5 w-5 mr-3 text-blue-600 flex-shrink-0" />
                                    <span className="font-medium text-[15px]">
                                        {providerName}
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div className="bg-blue-50 border border-blue-100 rounded-lg p-4 mb-6 text-left text-xs sm:text-sm text-blue-800">
                            <span className="font-semibold">Need to make a change?</span> Since our therapists travel directly to you, we kindly ask for 24 hours' notice to cancel or reschedule online. For last-minute emergencies, please call us at <a href="tel:+16172370589" className="font-semibold underline hover:text-blue-600 transition-colors">+1 (617) 237-0589</a>.
                        </div>

                        <div className="space-y-3">
                            <button
                                onClick={onViewAppointments}
                                className="w-full px-4 py-3 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-colors shadow-sm"
                            >
                                View My Appointments
                            </button>
                            <button
                                onClick={onClose}
                                className="w-full px-4 py-3 border border-gray-300 text-gray-700 font-medium rounded-lg hover:bg-gray-50 transition-colors"
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BookingConfirmationModal;